import { PieceSlider, PieceDescription, PieceUnorderedList } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const ABtestingPlatform = {
    name: 'A/B testing platform',
    slug: 'a-b-testing-platform',
    description: 'The Platform that compares a few versions of web pages to see which one performs better. Available as a service on the market. The main goal is to create testing variants of different pages, collecting user statistics, finalizing the winner variant. The source code of the winner variant is provided to the client.',
    cover: {
        url: `${PUBLIC_URL}/portfolio/a-b-testing/cover.jpg`,
        license: {
            link: 'http://www.freepik.com',
            text: 'Designed by vectorpocket / Freepik'
        }
    },
    prominentColor: 'rgb(199,195,191)',
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/portfolio/a-b-testing/backetball.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by vectorpocket / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/a-b-testing/school.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/a-b-testing/cover.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by vectorpocket / Freepik'
                    }
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Highlights',
            description: 'This service was acquired by Oracle',
        } as PieceDescription,
        {
            type: 'description',
            title: 'Role',
            description: 'JavaScript developer.',
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Main Technologies',
            items: ['Vanilla JS :)'],
        } as PieceUnorderedList,
    ],
}

export default ABtestingPlatform;


// WEBPACK FOOTER //
// ./src/store/portfolio/a-b-testing-platform.tsx